export const TextFormatter = () => {
  const formatText = (text) => {
    if (!text) {
      return '';
    }

    const lines = text.split(/\r\n|\r|\n/);
    const result = [];
    let currentList = null;
    let currentListType = '';
    let paragraphBuffer = [];

    /**
     * Closes the current list and adds it to the result array.
     */
    const closeList = () => {
      if (currentList && currentListType) {
        result.push(`<${currentListType}>${currentList.join('')}</${currentListType}>`);
        currentList = null;
        currentListType = '';
      }
    };

    /**
     * Flushes the paragraph buffer and adds it as a <p> tag to the result array.
     */
    const flushParagraph = () => {
      if (paragraphBuffer.length) {
        result.push(`<p>${paragraphBuffer.join('<br>')}</p>`);
        paragraphBuffer = [];
      }
    };

    lines.forEach(line => {
      const trimmedLine = line.trim();

      const orderedMatch = trimmedLine.match(/^(\d+)\.\s+(.*)/);
      const unorderedMatch = trimmedLine.match(/^[-*]\s+(.*)/);

      if (orderedMatch || unorderedMatch) {
        flushParagraph();

        const listItemContent = orderedMatch ? orderedMatch[2] : unorderedMatch[1];
        const newListType = orderedMatch ? 'ol' : 'ul';

        if (currentListType !== newListType) {
          closeList();
          currentList = [];
          currentListType = newListType;
        }
        currentList.push(`<li>${listItemContent}</li>`);
        return;
      }

      if (!trimmedLine) {
        closeList();
        flushParagraph();
        return;
      }

      closeList();
      paragraphBuffer.push(trimmedLine);
    });

    closeList();
    flushParagraph();

    return result.join('\n');
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const getTextWidth = (text, font) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
  };

  const truncateString = (text, maxWidth, font = '16px Arial') => {
    if (!text) return '';
    if (getTextWidth(text, font) <= maxWidth) return text;

    let start = 0, end = text.length;
    let truncatedText = text;

    while (start <= end) {
      const mid = Math.floor((start + end) / 2);
      truncatedText = text.slice(0, mid) + '...';
      const width = getTextWidth(truncatedText, font);

      if (width > maxWidth) {
        end = mid - 1;
      } else {
        start = mid + 1;
      }
    }

    return truncatedText;
  };

  const truncateHtmlText = (value, limit = 380) => {
    if (!value) return '';

    const text = value.replace(/<[^>]*>/g, '');
    return text.length > limit ? text.slice(0, limit) + '...' : text;
  };

  return {
    formatText,
    capitalizeFirstLetter,
    truncateString,
    truncateHtmlText,
  };
};
